<template>
  <div v-if="isMobile() == 'ios'">
    <ul class="store">
      <li><a href="//apps.apple.com/jp/app/id1193135691" target="_blank" rel="noopener"><img src="@/assets/img/badge-appstore.png" loading="lazy" alt="App Storeからダウンロード"></a></li>
    </ul>
  </div>
  <div v-else-if="isMobile() == 'android'">
    <ul class="store">
      <li><a href="//play.google.com/store/apps/details?id=com.netmarble.revolutionjp" target="_blank" rel="noopener"><img src="@/assets/img/badge-googleplay.png" loading="lazy" alt="Google Playで手に入れよう"></a></li>
    </ul>
  </div>
  <div v-else>
    <ul class="store">
      <li><a href="//apps.apple.com/jp/app/id1193135691" target="_blank" rel="noopener"><img src="@/assets/img/badge-appstore.png" loading="lazy" alt="App Storeからダウンロード"></a></li>
      <li><a href="//play.google.com/store/apps/details?id=com.netmarble.revolutionjp" target="_blank" rel="noopener"><img src="@/assets/img/badge-googleplay.png" loading="lazy" alt="Google Playで手に入れよう"></a></li>
    </ul>
  </div>
</template>

<style lang="scss">
.store {
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  top: 95.2rem;
  z-index: 2;
  @media (min-width: 829px) {
    display: flex;
    justify-content: center;
    top: 69.3rem;
  }
  li {
    background: #000;
    border: 1px solid #6e6868;
    border-radius: 1rem;
    height: 13rem;
    margin: 0 auto;
    width: 44.2rem;
    @media (min-width: 829px) {
      height: 6.6rem;
      margin: 0;
      width: 21.8rem;
    }
    a {
      display: block;
      height: 100%;
      padding-top: 2.7rem;
      @media (min-width: 829px) {
        padding-top: 1.6rem;
      }
      img {
        margin: 0 auto;
        width: 29.4rem;
        @media (min-width: 829px) {
          width: 14rem;
        }
      }
    }
    ~ li {
      margin-top: 1rem;
      @media (min-width: 829px) {
        margin: 0 0 0 2.5rem;
      }
    }
  }
}
</style>

<script>
const userAgent = navigator.userAgent;

export default {
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
        if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i) || userAgent.match(/iPod/i)) {
          return 'ios'
        } else {
          return 'android'
        }
      } else {
        return false
      }
    }
  }
}
</script>
